import React from "react";

function BS4_JS_Toasts() {
  return (
    <div>
      <h1>BS4_JS_Toasts Component</h1>
      <p>This is the BS4_JS_Toasts tutorial page content.</p>
    </div>
  );
}

export default BS4_JS_Toasts;
